<!--
  - Copyright Huesik (c) 2019.
  -->

<template>
  <div class="wrapper">
    <div class="inner-wrapper">
      <img src="../assets/images/call-image.jpg" />
    </div>

  </div>
</template>

<script>
  export default {
    name: 'CallPage',
    methods: {
      getParameterByName(name, url) {
        if (!url) url = window.location.href
        name = name.replace(/[\[\]]/g, '\\$&')
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
        const results = regex.exec(url)
        if (!results) return null
        if (!results[2]) return ''
        return decodeURIComponent(results[2].replace(/\+/g, ' '))
      }
    },
    mounted() {
      const userPhoneNo = this.getParameterByName('call_number')
      const phoneNoRegExp = /^\d{3}-?\d{3,4}-?\d{4}$/
      if (!userPhoneNo || !phoneNoRegExp.test(userPhoneNo)) {
        alert('잘못된 경로로 접근하였습니다.')
        return
      }

      location.href = `tel://${userPhoneNo}`
    }
  }
</script>

<style scoped lang="less">
  .wrapper {
    background: white;
    overflow: hidden;
    .inner-wrapper {
      width: 100vw;
      height: 100vh;
      padding-top: 6.25rem;
      box-sizing: border-box;
      img {
        width: 100%;
        padding: 0 6.25rem;
        box-sizing: border-box;
      }
    }
  }
</style>
